import { Directive, Input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';
import * as _ from 'lodash-es';

const BVD_ID_SEPARATOR = ',';
export const BVD_VALIDATOR_ERROR = { appBvdIdsLimit: true };
export const BVD_DEFAULT_LIMIT = 50;
@Directive({
  selector: '[appBvdIdsLimit]',
  providers: [{ provide: NG_VALIDATORS, useExisting: BvdIdsLimitDirective, multi: true }],
})
export class BvdIdsLimitDirective implements Validator {
  @Input('appBvdIdsLimit') limit = BVD_DEFAULT_LIMIT;

  validate(control: AbstractControl): ValidationErrors {
    return !_.isEmpty(control.value) && control.value.split(BVD_ID_SEPARATOR).length >= this.limit + 1 ? BVD_VALIDATOR_ERROR : null;
  }
}
